/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AddressViewModel } from './AddressViewModel';
import {
    AddressViewModelFromJSON,
    AddressViewModelFromJSONTyped,
    AddressViewModelToJSON,
} from './AddressViewModel';

/**
 * 
 * @export
 * @interface IndividualAddressesViewModel
 */
export interface IndividualAddressesViewModel {
    /**
     * 
     * @type {number}
     * @memberof IndividualAddressesViewModel
     */
    partyId: number;
    /**
     * 
     * @type {AddressViewModel}
     * @memberof IndividualAddressesViewModel
     */
    physicalAddress?: AddressViewModel;
    /**
     * 
     * @type {AddressViewModel}
     * @memberof IndividualAddressesViewModel
     */
    postalAddress?: AddressViewModel;
}

/**
 * Check if a given object implements the IndividualAddressesViewModel interface.
 */
export function instanceOfIndividualAddressesViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "partyId" in value;

    return isInstance;
}

export function IndividualAddressesViewModelFromJSON(json: any): IndividualAddressesViewModel {
    return IndividualAddressesViewModelFromJSONTyped(json, false);
}

export function IndividualAddressesViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): IndividualAddressesViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partyId': json['PartyId'],
        'physicalAddress': !exists(json, 'PhysicalAddress') ? undefined : AddressViewModelFromJSON(json['PhysicalAddress']),
        'postalAddress': !exists(json, 'PostalAddress') ? undefined : AddressViewModelFromJSON(json['PostalAddress']),
    };
}

export function IndividualAddressesViewModelToJSON(value?: IndividualAddressesViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PartyId': value.partyId,
        'PhysicalAddress': AddressViewModelToJSON(value.physicalAddress),
        'PostalAddress': AddressViewModelToJSON(value.postalAddress),
    };
}

